import * as React from 'react';

import {
  getChatAnimationCounter,
  getPrevPathCookie,
  incrementChatAnimationCounter,
  setPrevPathCookie,
} from '../utils/chatAnimationCounter';

export const useChatAnimationCounter = () => {
  const [counter, setCounter] = React.useState(() => getChatAnimationCounter());
  const [isFirstVisit, setIsFirstVisit] = React.useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    // istanbul ignore next
    if (typeof window === 'undefined') {
      return;
    }

    const currentPath = window.location.pathname + window.location.search;
    const prevPath = getPrevPathCookie();

    if (prevPath === null) {
      // Первый раз - определяем видимость анимации на основе текущего каунтера + 1
      // но не обновляем каунтер в куке до тех пор, пока анимация не начнется
      const currentCounter = 0;
      const nextCounter = currentCounter + 1;

      setCounter(nextCounter);
      setIsFirstVisit(true);
      setPrevPathCookie(currentPath);

      return;
    }

    if (prevPath !== currentPath) {
      const currentCounter = getChatAnimationCounter();
      // Если счетчик = 0 и это не первый заход, значит анимация не открутилась при первом заходе
      // В этом случае показываем анимацию на следующей выдаче
      if (currentCounter === 0) {
        setCounter(0);
        setIsFirstVisit(true);
        setPrevPathCookie(currentPath);

        return;
      }

      const nextCounter = currentCounter + 1;
      setCounter(nextCounter);
      setIsFirstVisit(false);
      // Проверяем, должна ли показываться анимация на следующей выдаче
      // Анимация показывается когда nextCounter кратно 5 (5, 10, 15, 20...)
      const isAnimationVisible = nextCounter % 5 === 0;
      // Обновляем счетчик в куке только если анимация не видна
      // Если анимация видна, счетчик будет обновлен в handleAnimationStarted
      if (!isAnimationVisible) {
        incrementChatAnimationCounter();
      }
      setPrevPathCookie(currentPath);
    }
  });

  const incrementCounter = React.useCallback(() => {
    const newCounter = incrementChatAnimationCounter();
    setCounter(newCounter);

    return newCounter;
  }, []);

  return { counter, incrementCounter, isFirstVisit };
};
